import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const DensityContext = /*#__PURE__*/createContext({
  density: 'medium'
});
export const Density = ({
  density,
  children
}) => {
  return /*#__PURE__*/_jsx(DensityContext.Provider, {
    value: {
      density
    },
    children: children
  });
};
export const useDensity = () => {
  const context = useContext(DensityContext);
  return context ?? {
    density: 'medium'
  };
};
export const renderDensityDesignTokens = density => {
  return density === 'high' ? {} : {};
};
//# sourceMappingURL=Density.js.map